import { createContext, useContext } from 'react';

import { PlatMapSettings } from '@mono/types/src/platmap';
import { defaultPlatMapSettings } from '@mono/platmap-default-settings';

export const SettingsContext = createContext<{
    settings: PlatMapSettings;
    setSettings?: React.Dispatch<React.SetStateAction<PlatMapSettings>>;
}>({
    settings: defaultPlatMapSettings,
    setSettings: undefined,
});

export const useSettingsContext = () => useContext(SettingsContext);
